<!-- eslint-disable max-len -->
<template>
  <div class="">
    <div class="overlay" v-if="Literacy"></div>
    <div class="head-card">
      <div class="float-right">
        <router-link to="profile"><img src="@/assets/user.png" height="25" width="25" alt="Logo"
            style="float: right"></router-link>
      </div>
      <div class="account_balance">
        <p class="secondary">Total Balance</p>
        <p class="balance cabin-family semi-bold">₦ {{ Number(balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
        <!-- eslint-disable-next-line max-len -->
        <!-- <button class="btn withdrawal-btn" v-if="userType != 'smart-academy'" @click="openWithdrawal">Withdraw</button> -->
        <button class="btn withdrawal-btn" @click="openWithdrawal">Withdraw</button>
      </div>

      <div class="action-cards" v-if="userType != 'smart-academy' || userType != 'smart-general'">
        <!-- <div class="action-card">
          <img src="@/assets/invested.png" height="30" width="30" alt="Logo">
          <div class="text-left ml-2">
            <p class="secondary fnt-10 mb-0 lh-12">Amount Saved</p>
            <p class="cabin-family bold mb-0">₦ {{ Number(invested).toLocaleString() }}.00</p>
          </div>
        </div>
        <div class="action-card">
          <img src="@/assets/returns.png" height="30" width="30" alt="Logo">
          <div class="text-left ml-2">
            <p class="secondary fnt-10 mb-0 lh-12">Portfolio value</p>
            <p class="cabin-family bold mb-0">₦ {{ Number(roi).toLocaleString() }}.00</p>
          </div>
        </div> -->
      </div>
      <button class="btn primary-btn btn-block" @click="fund">Fund Wallet</button>
    </div>
    <!-- General User Content -->
    <div class="content" v-if="userType == 'smart-mina'">
      <!-- MINA Introduction Section -->

      <h2 class="premium-title">MINA&trade; PRO - Your Money Mastery Buddy</h2>
        <p class="premium-subtitle">
          <!-- eslint-disable-next-line max-len -->
          What can you do on MINA&trade;
        </p>
      <div class="three-column-grid">
        <div class="grid-item" @click="openBudgets">
          <div class="grid-icon">
            <img src="@/assets/card.png" height="30" width="30" alt="Budget">
          </div>
          <div class="grid-content">
            <p class="cabin-family bold">Budgeting</p>
          </div>
        </div>
        <div class="grid-item" @click="openGoals">
          <div class="grid-icon">
            <img src="@/assets/invested.png" height="30" width="30" alt="Goals">
          </div>
          <div class="grid-content">
            <p class="cabin-family bold">Savings Goal</p>
          </div>
        </div>
        <div class="grid-item" @click="lockFunds">
          <div class="grid-icon">
            <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
          </div>
          <div class="grid-content">
            <p class="cabin-family bold">Safelock</p>
          </div>
        </div>
      </div>

      <div class="three-column-grid">
        <div class="grid-item" @click="openMinaInvestments">
          <div class="grid-icon">
            <img src="@/assets/card.png" height="30" width="30" alt="Budget">
          </div>
          <div class="grid-content">
            <p class="cabin-family bold">Investment</p>
          </div>
        </div>
        <div class="grid-item" @click="openResources">
          <div class="grid-icon">
            <img src="@/assets/invested.png" height="30" width="30" alt="Goals">
          </div>
          <div class="grid-content">
            <p class="cabin-family bold">MINA&trade; PRO Courses <br> (Leads Resource Videos)</p>
          </div>
        </div>
        <div class="grid-item" @click="switchToSmartSteward">
          <div class="grid-icon">
            <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
          </div>
          <div class="grid-content">
            <p class="cabin-family bold">Smart Stewards</p>
          </div>
        </div>
      </div>
       <!-- eslint-disable-next-line max-len -->
      <p>Mina™ by Smart Stewards isn't just another financial literacy program—it's your complete starter plan for a lifetime of wealth-building. Mina™ is designed to teach, guide, and empower you to confidently handle money in a simple, practical, and lasting way.</p>
      <!-- More from Smart Stewards Premium Plans Section -->
      <div class="premium-plans-section">
        <h2 class="premium-title">More from Smart Stewards</h2>
        <p class="premium-subtitle">
          While MINA™ is your starting point, you can achieve more on your journey to
          financial freedom.<br>
          Check out your next level plans
        </p>
        <div class="premium-plan-card">
          <div class="plan-header">
            <h3 class="plan-title">Premium Wealth Plan</h3>
          </div>
          <div class="plan-content">
            <p class="plan-description">
              The ultimate package for those who want continuous learning, support, and growth
              throughout the year.
            </p>
            <p class="plan-details">
              This plan is perfect if you're committed to long-term financial transformation
              and ongoing personal development.
            </p>
          </div>
        </div>

        <div class="premium-plan-card">
          <div class="plan-header">
            <h3 class="plan-title">Fit-To-Fly Financial Plan</h3>
          </div>
          <div class="plan-content">
            <p class="plan-description">
              The ultimate package for those who want continuous learning, support,
              and growth for 24 months.
            </p>
            <p class="plan-details">
              The Fit-To-Fly Financial Plan is your ticket to financial readiness,
              ensuring you're set up for success wherever life takes you.
            </p>
          </div>
        </div>

        <div class="premium-cta">
          <button class="btn premium-btn btn-block" @click="viewAllPlans">
            View All Smart Stewards Academy Plans
          </button>
        </div>
      </div>

      <div
        v-if="$store.getters.user_types.includes('smart-steward')"
        class="switch-dashboard-card switch-dashboard-card--steward"
        style="margin: 0 2rem 1rem;"
        @click="switchToSmartSteward"
      >
        <div class="switch-dashboard-card__text">
          <p class="switch-dashboard-card__title">Switch to Smart Steward</p>
          <p class="switch-dashboard-card__subtitle">Back to your investment dashboard</p>
        </div>
        <span class="switch-dashboard-card__arrow">&#8594;</span>
      </div>

      <div class="connect-footer">
        <div class="footer-content">
          <div class="footer-section">
            <h5 class="footer-title">Connect With Us</h5>
            <p class="footer-subtitle">Stay connected for updates and support</p>
          </div>

          <div class="social-links">
            <div class="social-item" @click="openWhatsApp">
              <div class="social-icon whatsapp">
                <i class="fab fa-whatsapp"></i>
              </div>
              <div class="social-info">
                <span class="social-name">WhatsApp</span>
                <span class="social-handle">+234 901 909 3340</span>
              </div>
            </div>

            <div class="social-item" @click="openInstagram">
              <div class="social-icon instagram">
                <i class="fab fa-instagram"></i>
              </div>
              <div class="social-info">
                <span class="social-name">Instagram</span>
                <span class="social-handle">@smartstewards</span>
              </div>
            </div>

            <div class="social-item" @click="openLinkedIn">
              <div class="social-icon linkedin">
                <i class="fab fa-linkedin"></i>
              </div>
              <div class="social-info">
                <span class="social-name">LinkedIn</span>
                <span class="social-handle">Smart Stewards Company</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Existing Content for smart-steward and mastermind users -->
    <div class="content" v-else>
      <h4>Featured Video</h4>
      <!-- <div class="feeds-card" v-if="banner.status === 'active' "> -->
      <iframe width="350" height="200" frameBorder="0" :src="`https://www.youtube.com/embed/${videoId}`"></iframe>
      <!-- </div> -->

      <h4 style="margin-top: 8px;">Before you start Investing...</h4>
      <div class="links-card">
        <a href="https://res.cloudinary.com/kingleo/image/upload/v1625752600/SMART_STEWARDS-_CODE_OF_CONDUCT_FOR_CLUB_MEMBERS_ehcemi.pdf"
          target="_blank">
          <div class="links-card-section">
            <div class="second-col">
              <p class="cabin-family bold">Smart Stewards - Code of Conduct</p>
            </div>
            <div class="third-col">
              <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
            </div>
          </div>
        </a>
      </div>
      <div class="links-card">
        <a href="https://res.cloudinary.com/kingleo/image/upload/v1656584747/SIC_Members_NOK_fillable_form_bo94m9.pdf"
          target="_blank">
          <div class="links-card-section">
            <div class="second-col">
              <p class="cabin-family bold">Smart Investment Club Next of Kin/Investment Form</p>
            </div>
            <div class="third-col">
              <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
            </div>
          </div>
        </a>
      </div>
      <div class="links-card">
        <a href="https://res.cloudinary.com/kingleo/image/upload/v1656584747/THE_UPDATED_SMART_INVESTMENT_CLUB_CUSTOMER_JOURNEY_MAP_pscifu.pdf"
          target="_blank">
          <div class="links-card-section">
            <div class="second-col">
              <p class="cabin-family bold">Smart Investment Club Customer Journey Map</p>
            </div>
            <div class="third-col">
              <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
            </div>
          </div>
        </a>
      </div>
      <div class="links-card">
        <div class="links-card-section" @click="openLiteracy">
          <div class="first-col">
            <img src="@/assets/literacy.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Risk Profile Assessment</p>
            <p class="sub-text">Fill out this questionnaire to know your risk profile</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
          </div>
        </div>
      </div>

      <h4>Investments</h4>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openInvestments" v-if="userType !== 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/investments.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Investments</p>
          <p class="sub-text">View all investments on Smart Stewards</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openAngelInvesting" v-if="userType != 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/investment.svg" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Angel Investing</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Cooperative</h4>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openCooperative" v-if="userType != 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/cooperation.svg" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">SIC Cooperative</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Resources</h4>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/rn-ncJ2mnYg')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Canada Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/AIpDbXW32gQ')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Nigeria Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=X9sBT3CYUDU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up United Kingdom Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=r-9Y5-VgxoU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Ghana Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Links</h4>
      <div class="links-card">
        <div class="links-card-section" @click="toggle(4)">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Your Unique Referral Link</p>
            <p class="sub-text">Invite Your Friends and Get Paid</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv4" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv4">
          <div class="text-center" @click="copyText()">
            <p class="cabin-family secondary bold fnt-16">
              {{ referralLink }}</p>
            <p class="copy-text cabin-family">Click to copy.</p>
          </div>
        </div>
      </div>
      <div class="links-card">
        <div class="links-card-section" @click="toggle(1)" v-if="userType != 'smart-starter'">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">United Capital Funds</p>
            <p class="sub-text"></p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv1" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv1">
          <ol>
            <li><a href="https://investnow.ng/signup/AM_EURO/OREA23" target="_blank">Nigerian Eurobond
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
            <li><a href="https://investnow.ng/signup/AM/OREA23" target="_blank">Money Market
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
            <li><a href="https://investnow.ng/signup/AM_BON/OREA23" target="_blank">Fixed Income Fund
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
          </ol>
        </div>

        <div class="links-card-section" @click="toggle(2)" v-if="userType != 'smart-starter'">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Buy US Stocks</p>
            <p class="sub-text"></p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv2" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv2">
          <ol>
            <li><a href=" https://app.investbamboo.com/invite/adesola259133" target="_blank">Bamboo ( Buy from Nigeria)
                <img src="@/assets/foreign.svg" height="12" width="12" alt="Logo"></a></li>
          </ol>
        </div>
        <div class="links-card-section" @click="toggle(3)" v-if="userType != 'smart-starter'">
          <div class="first-col">
            <img src="@/assets/bank-transfer.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Register your US business through Smart Stewards</p>
            <p class="sub-text"></p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" v-if="!showDiv3" height="11" width="6" alt="Logo">
            <img src="@/assets/down-chevron.png" v-else height="6" width="11" alt="Logo">
          </div>
        </div>
        <div class="links-card-section" v-if="showDiv3">
          <ol>
            <li>Get your US Bank Account</li>
            <li>US Phone number / address </li>
            <li>Get customized support </li>
            <li>File Your Taxes </li>
            <a href="https://smartstewards.com/us-business/" target="_blank">https://smartstewards.com/us-business/
            </a>
          </ol>
        </div>
        <div class="links-card-section" @click="smartAcademy">
          <div class="first-col">
            <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Smart Stewards Academy</p>
            <p class="sub-text">Visit our academy to get content to help you boost your
              financial literacy</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
          </div>
        </div>
      </div>

      <div class="transactions" v-if="transactions.length > 0">
        <h4>Transactions</h4>
        <div class="trans-table">
          <!-- eslint-disable-next-line max-len -->
          <div class="trans-table-row" v-for="(trans, ind) in transactions.slice().reverse()" :key="ind">
            <div class="row1">
              <p class="p1">{{ trans.description }}</p>
              <p class="p2">{{ trans.createdAt | formatDate }}</p>
            </div>
            <div class="row2">
              <p>₦{{ Number(trans.amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="switch-dashboard-card switch-dashboard-card--mina"
        @click="switchToSmartMina"
      >
        <div class="switch-dashboard-card__text">
          <p class="switch-dashboard-card__title">Switch to MINA&trade; PRO</p>
          <p class="switch-dashboard-card__subtitle">Budgeting, goals &amp; savings dashboard</p>
        </div>
        <span class="switch-dashboard-card__arrow">&#8594;</span>
      </div>
    </div>
    <div class="content" v-if="userType === 'smart-academy'">
      <h4>Savings</h4>
      <div class="links-card-section inv" @click="lockFunds">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Safelock</p>
          <p class="sub-text">Lock wallet funds to accrue interests</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(7)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Smart stewards summit 2024 savings challenge</p>
          <p class="sub-text">Save towards the 2024 smart stewards summit</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(1)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦750,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦750,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(2)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦1,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦1,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(3)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦5,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦5,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSavingsChallenge(4)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">₦10,000,000 savings challenge</p>
          <p class="sub-text">Save an extra ₦10,000,000 in 2024</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Financial Planning</h4>
      <div class="links-card-section inv" @click="openBudgets">
        <div class="first-col">
          <img src="@/assets/card.png" height="30" width="30" alt="Budget">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Budget Management</p>
          <p class="sub-text">Create and track your budgets to control spending</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openGoals">
        <div class="first-col">
          <img src="@/assets/invested.png" height="30" width="30" alt="Goals">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Financial Goals</p>
          <p class="sub-text">Set and track your financial goals and savings targets</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Cooperative</h4>
      <!-- eslint-disable-next-line max-len -->
      <div class="links-card-section inv" @click="openCooperative" v-if="userType != 'smart-starter'">
        <div class="first-col">
          <img src="@/assets/cooperation.svg" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">SIC Cooperative</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Resources</h4>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/rn-ncJ2mnYg')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Canada Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/AIpDbXW32gQ')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Nigeria Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=X9sBT3CYUDU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up United Kingdom Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=r-9Y5-VgxoU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Ghana Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
    </div>
    <div class="content" v-if="userType === 'smart-general'">
      <p><span class="bold">Welcome To Smart Stewards:</span> One of Nigeria's Leading Financial
        Literacy Organizations, helping Africans at home and in the diaspora to build wealth</p>
      <p class="bold mt-3">How to save. </p>
      <p>Step 1: Fund your wallet</p>
      <p>Step 2: Get a virtual bank account no</p>
      <p>Step 3 : Make a transfer</p>
      <p>Step 4: Click the link below to save.</p>
      <h4 class="text-left mt-3">Savings</h4>
      <div class="links-card-section inv" @click="smartAcademy">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Join The Smart Stewards Academy Today
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openSmartStewards">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Read More About Smart Stewards
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <iframe width="350" height="200" frameBorder="0" :src="`https://www.youtube.com/embed/uyDoNfmvH98`"></iframe>

      <iframe width="350" height="200" frameBorder="0" :src="`https://www.youtube.com/embed/HcX8YYotbj8`"></iframe>

      <h4>Savings</h4>
      <div class="links-card-section inv" @click="openSavingsChallenge(7)">
        <div class="first-col">
          <img src="@/assets/lock.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Smart stewards summit 2024 savings challenge</p>
          <p class="sub-text">Save towards the 2024 smart stewards summit</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Financial Planning</h4>
      <div class="links-card-section inv" @click="openBudgets">
        <div class="first-col">
          <img src="@/assets/card.png" height="30" width="30" alt="Budget">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Budget Management</p>
          <p class="sub-text">Create and track your budgets to control spending</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openGoals">
        <div class="first-col">
          <img src="@/assets/invested.png" height="30" width="30" alt="Goals">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Financial Goals</p>
          <p class="sub-text">Set and track your financial goals and savings targets</p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

      <h4>Resources</h4>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/rn-ncJ2mnYg')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Canada Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://youtu.be/AIpDbXW32gQ')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Nigeria Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=X9sBT3CYUDU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up United Kingdom Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>
      <div class="links-card-section inv" @click="openYoutube('https://www.youtube.com/watch?v=r-9Y5-VgxoU')">
        <div class="first-col">
          <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
        </div>
        <div class="second-col">
          <p class="cabin-family bold">Gas-Up Ghana Webinar
          </p>
        </div>
        <div class="third-col">
          <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
        </div>
      </div>

    </div>
    <bank @close="closeLiteracy" v-if="!userBank"></bank>
    <literacy-component @close="closeLiteracy" v-if="Literacy"></literacy-component>
  </div>
</template>

<script>
import LiteracyComponent from './Literacy.vue';
import Bank from '../components/Bank.vue';
import { withWalletTypeParams } from '../utils/walletType';

export default {
  components: {
    LiteracyComponent,
    Bank,
  },
  data() {
    return {
      Literacy: false,
      showDiv1: false,
      showDiv2: false,
      showDiv3: false,
      showDiv4: false,
      risk_appetite: '',
      transactions: {},
      balance: 0,
      roi: 0,
      userBank: 'active',
      invested: 0,
      banner: {},
      referralCode: '',
      lastname: '',
      userCooperative: '',
      videoId: '',
      userInvestments: [],
      showInvestmentNotice: false,
    };
  },
  computed: {
    userType() {
      return this.$store.getters.selectedUserType || '';
    },
    referralLink() {
      return `https://smartstewards-app.netlify.app/signup?referral=${this.referralCode}`;
    },
  },
  created() {
    this.getWallet();
    this.risk_appetite = localStorage.getItem('risk_appetite');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.lastname = user.lastname || '';
    this.referralCode = user.referral_code || '';
    this.userCooperative = !!user.cooperative;
    const investmentPop = localStorage.getItem('investment-pop');
    if (!investmentPop) {
      this.showInvestmentNotice = true;
      localStorage.setItem('investment-pop', 'Investment pop up');
    }
  },
  methods: {
    async getWallet() {
      const params = withWalletTypeParams(this.$store);
      const url = `${this.$baseUrl}/wallet`;
      const res = await this.$http({ url, method: 'GET', params });
      this.transactions = res.data.transactions;
      this.userInvestments = res.data.userInvestments;
      this.balance = res.data.balance || 0;
      this.roi = res.data.roi || 0;
      this.invested = res.data.invested || 0;
      const banner = res.data.banner || {};
      const [, videoId] = (banner.image_url || '=').split('=');
      this.videoId = videoId;
      this.userBank = res.data.userBankActive;
      localStorage.setItem('balance', this.balance);
    },
    fund() {
      this.$router.push('fund');
    },
    investments() {
      this.$router.push('investments');
    },
    profile() {
      this.$router.push('profile');
    },
    openInvestments() {
      this.$router.push('/investments');
    },
    openBudgets() {
      this.$router.push('/budgets');
    },
    openGoals() {
      this.$router.push('/goals');
    },
    openCooperative() {
      this.$router.push('/cooperative');
    },
    openCooperativeResources() {
      this.$router.push('/cooperative-resources');
    },
    openAngelInvesting() {
      this.$router.push('/angel-investment');
    },
    openWithdrawal() {
      this.$router.push('/withdrawals');
    },
    lockFunds() {
      this.$router.push('/savings');
    },
    openSavings() {
      this.$toast.open({
        message: 'Savings features are temporarily unavailable',
        type: 'warning',
        duration: 3000,
      });
    },
    openSavingsChallenge() {
      this.$toast.open({
        message: 'Savings features are temporarily unavailable',
        type: 'warning',
        duration: 3000,
      });
    },
    targetSavings() {
      this.$toast.open({
        message: 'Savings features are temporarily unavailable',
        type: 'warning',
        duration: 3000,
      });
    },
    openMinaInvestments() {
      this.$router.push('/mina-investments');
    },
    openResources() {
      this.$router.push('/resources');
    },
    openNetworth() {
      this.$router.push('/net-worth');
    },
    openYoutube(link) {
      window.open(link, '_blank');
    },
    openWhatsApp() {
      window.open('https://wa.me/2349019093340', '_blank');
    },
    openInstagram() {
      window.open('https://www.instagram.com/smartstewards/?hl=en', '_blank');
    },
    openLinkedIn() {
      window.open('https://www.linkedin.com/company/smart-stewards-the-smart-investment-club/?viewAsMember=true', '_blank');
    },
    smartAcademy() {
      window.open('https://academy.smartstewards.com/bundles/smart-stewards-short-money-courses', '_blank');
    },
    smartAcademy2() {
      window.open('https://academy.smartstewards.com', '_blank');
    },
    openSmartStewards() {
      window.open('https://smartstewards.com/', '_blank');
    },
    async switchToSmartMina() {
      try {
        await this.$store.dispatch('optInToSmartMina');
      } catch (e) {
        this.$toast.error('Could not switch dashboard. Please try again.');
      }
    },
    switchToSmartSteward() {
      const userTypes = this.$store.getters.user_types;
      if (userTypes.includes('smart-steward')) {
        this.$store.commit('set_selected_user_type', 'smart-steward');
      } else {
        window.open('https://smartstewards.com/', '_blank');
      }
    },
    viewAllPlans() {
      window.open('https://academy.smartstewards.com/', '_blank');
    },
    smartResources() {
      window.open('https://thesmartinvestmentclub.com/sic-resources/', '_blank');
    },
    smartCourses() {
      window.open('https://thesmartinvestmentclub.com/courses/sicintroductorycourse/', '_blank');
    },
    openLiteracy() {
      this.Literacy = true;
    },
    closeLiteracy() {
      this.Literacy = false;
      this.userBank = true;
      this.risk_appetite = localStorage.getItem('risk_appetite');
    },
    closeModal() {
      this.showInvestmentNotice = false;
    },
    async copyText() {
      try {
        await navigator.clipboard.writeText(this.referralLink);
        this.$toast.open('Copied to clipboard', {
          duration: 2500,
          type: 'success',
          dismissible: true,
        });
      } catch ($e) {
        console.log($e);
      }
    },
    toggle(id) {
      if (id === 1) {
        if (this.showDiv1) {
          this.showDiv1 = false;
        } else {
          this.showDiv1 = true;
        }
      } else if (id === 2) {
        if (this.showDiv2) {
          this.showDiv2 = false;
        } else {
          this.showDiv2 = true;
        }
      } else if (id === 3) {
        if (this.showDiv3) {
          this.showDiv3 = false;
        } else {
          this.showDiv3 = true;
        }
      } else if (id === 4) {
        if (this.showDiv4) {
          this.showDiv4 = false;
        } else {
          this.showDiv4 = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #EE0E4C;
  font-weight: 400;
  font-family: 'Cabin', sans-serif;
  text-decoration: none;
}

li {
  font-family: 'Cabin', sans-serif;

  img {
    margin-left: .25rem;
  }
}

.overlay {
  min-height: 100vh;
  width: 100%;
  background-color: #F9F9F9;
  position: fixed;
  top: 0;
}

p {
  margin-bottom: .25rem;
}

.balance {
  font-size: 32px;
  font-weight: 700;
  line-height: 35px;
  margin-bottom: 0;
}

.head-card {
  background-color: #FFF;
  padding: 2rem;
  border-radius: 0px 0px 25px 25px;
  text-align: center;

  .account_balance {
    margin: 2rem 0;
  }
}

.action-cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;

  .action-card {
    padding: 1rem .35rem;
    width: 47%;
    background-color: #FCFCFC;
    color: #000;
    border-radius: 8px;
    display: flex;
    align-items: center;
  }
}

.trans-table {
  padding: 1rem;
  border-radius: 8px;
  background-color: #FFF;

  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .45rem 0;
    border-bottom: 1px solid #E5E5E5;

    &:last-child {
      border-bottom: none;
    }
  }

  .row1 {
    display: flex;
    flex-direction: column;

    .p1 {
      font-size: 12px;
      line-height: 14px;
      font-family: 'Cabin', sans-serif;
    }

    .p2 {
      font-size: 8px;
      line-height: 12px;
      color: #49566A;
      font-family: 'Roboto', sans-serif;
    }
  }

  .row2 {
    p {
      font-family: 'Cabin', sans-serif;
      font-weight: 600;
    }
  }
}

.transactions {
  margin-top: 2rem;
}

.withdrawal-btn {
  font-family: 'Cabin', sans-serif;
  color: #FFF;
  background-color: #EE0E4C;
  border-color: #EE0E4C;
  padding: 0.25rem 0.75rem;
  border-radius: 8px;
  font-weight: 700;
  margin-top: .5rem;
}

.copy-text {
  font-size: 12px;
  color: #50A948;
  margin-bottom: 0;
}

.mina-intro-section {
  background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
  padding: 2rem;
  border-radius: 16px;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(238, 14, 76, 0.1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #EE0E4C, #FF6B9D, #EE0E4C);
  }

  h2 {
    color: #EE0E4C;
    margin-bottom: 1.5rem;
    font-size: 28px;
    line-height: 1.2;
    text-align: center;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background: linear-gradient(90deg, #EE0E4C, #FF6B9D);
      border-radius: 2px;
    }
  }

  h3 {
    color: #333;
    margin: 2rem 0 1.5rem 0;
    font-size: 20px;
    text-align: center;
  }

  .intro-text {
    color: #555;
    line-height: 1.7;
    margin-bottom: 2rem;
    font-size: 17px;
    text-align: center;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .benefits-list {
    margin-bottom: 2.5rem;

    .benefit-item {
      margin-bottom: 1.5rem;
      padding: 1.5rem;
      background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
      border-radius: 12px;
      border-left: 5px solid #EE0E4C;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      position: relative;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(238, 14, 76, 0.15);
        border-left-color: #FF6B9D;
      }

      h4 {
        color: #EE0E4C;
        margin-bottom: 0.75rem;
        font-size: 18px;
        font-weight: 600;
      }

      p {
        color: #666;
        margin-bottom: 0;
        line-height: 1.6;
        font-size: 15px;
      }
    }
  }

  .cta-section {
    text-align: center;

    .btn {
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      border: none;
      color: white;
      padding: 1rem 2.5rem;
      border-radius: 12px;
      font-weight: 600;
      text-decoration: none;
      display: inline-block;
      transition: all 0.3s ease;
      box-shadow: 0 4px 16px rgba(238, 14, 76, 0.3);
      font-size: 16px;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 24px rgba(238, 14, 76, 0.4);
        background: linear-gradient(135deg, #C00D3F 0%, #EE0E4C 100%);
      }
    }
  }
}

.steps-section {
  background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
  padding: 2rem;
  border-radius: 16px;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(238, 14, 76, 0.1);

  .step-item {
    display: flex;
    align-items: center;
    margin-bottom: 1.5rem;
    padding: 1.25rem;
    background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      transform: translateX(8px);
      box-shadow: 0 8px 24px rgba(238, 14, 76, 0.15);
    }

    .step-number {
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      color: white;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 700;
      margin-right: 1.5rem;
      flex-shrink: 0;
      box-shadow: 0 4px 12px rgba(238, 14, 76, 0.3);
    }

    .step-text {
      color: #333;
      font-size: 15px;
      line-height: 1.5;
      font-weight: 500;
    }
  }
}

.course-intro {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
  font-size: 16px;
}

.course-plans {
  background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
  padding: 2rem;
  border-radius: 16px;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(238, 14, 76, 0.1);

  .course-plan-item {
    padding: 1.5rem;
    background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
    border-radius: 12px;
    margin-bottom: 1.5rem;
    border-left: 5px solid #EE0E4C;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(238, 14, 76, 0.15);
      border-left-color: #FF6B9D;
    }

    h5 {
      color: #EE0E4C;
      margin-bottom: 0.75rem;
      font-size: 18px;
      font-weight: 600;
    }

    p {
      color: #666;
      margin-bottom: 0;
      line-height: 1.6;
      font-size: 15px;
    }
  }
}

.video-section {
  background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
  padding: 2rem;
  border-radius: 16px;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(238, 14, 76, 0.1);

  .video-item {
    display: flex;
    align-items: center;
    padding: 1.5rem;
    background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
    border-radius: 12px;
    margin-bottom: 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      color: white;
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(238, 14, 76, 0.3);

      .video-thumbnail {
        background: white;
        color: #EE0E4C;
        transform: scale(1.1);
      }

      .video-play {
        color: white;
        transform: scale(1.2);
      }

      .sub-text {
        color: rgba(255, 255, 255, 0.9);
      }
    }

    .video-thumbnail {
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      color: white;
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1.5rem;
      font-size: 20px;
      box-shadow: 0 4px 12px rgba(238, 14, 76, 0.3);
      transition: all 0.3s ease;
    }

    .video-info {
      flex: 1;

      p {
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .video-play {
      color: #EE0E4C;
      font-size: 18px;
      transition: all 0.3s ease;
    }
  }
}

.investment-section {
  background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
  padding: 2rem;
  border-radius: 16px;
  margin-bottom: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(238, 14, 76, 0.1);

  .investment-card {
    display: flex;
    align-items: center;
    padding: 1.5rem;
    background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
    border-radius: 12px;
    margin-bottom: 2rem;
    border-left: 5px solid #EE0E4C;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(238, 14, 76, 0.15);
      border-left-color: #FF6B9D;
    }

    .investment-icon {
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      color: white;
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1.5rem;
      font-size: 20px;
      box-shadow: 0 4px 12px rgba(238, 14, 76, 0.3);
    }

    .investment-content {
      flex: 1;

      h5 {
        color: #EE0E4C;
        margin-bottom: 0.5rem;
        font-size: 18px;
        font-weight: 600;
      }

      p {
        color: #666;
        margin-bottom: 0;
        font-size: 15px;
        line-height: 1.5;
      }
    }
  }

  .investment-cta {
    text-align: center;
  }
}

.connect-footer {
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
  margin: 2rem -1rem -1rem -1rem;
  padding: 2rem 1rem 1.5rem 1rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #EE0E4C 0%, #FF6B9D 100%);
  }

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    right: -20%;
    width: 200px;
    height: 200px;
    background: rgba(238, 14, 76, 0.1);
    border-radius: 50%;
  }

  .footer-content {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-section {
    text-align: center;
    margin-bottom: 2rem;
  }

  .footer-title {
    color: white;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    font-family: 'Cabin', sans-serif;
  }

  .footer-subtitle {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.95rem;
    margin: 0;
  }

  .social-links {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
  }

  .social-item {
    display: flex;
    align-items: center;
    padding: 1rem;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: translateY(-2px);
      border-color: rgba(238, 14, 76, 0.3);

      .social-icon {
        transform: scale(1.1);
      }

      .social-name {
        color: #FF6B9D;
      }
    }

    .social-icon {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 1rem;
      font-size: 18px;
      color: white;
      transition: all 0.3s ease;
      flex-shrink: 0;

      &.whatsapp {
        background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
      }

      &.instagram {
        background: linear-gradient(135deg, #E4405F 0%, #C13584 100%);
      }

      &.linkedin {
        background: linear-gradient(135deg, #0077B5 0%, #005885 100%);
      }
    }

    .social-info {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .social-name {
      color: white;
      font-size: 0.95rem;
      font-weight: 600;
      margin-bottom: 0.25rem;
      transition: color 0.3s ease;
      font-family: 'Cabin', sans-serif;
    }

    .social-handle {
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.85rem;
      margin: 0;
    }
  }

  // Responsive Design
  @media (max-width: 768px) {
    margin: 2rem -0.75rem -0.75rem -0.75rem;
    padding: 1.5rem 0.75rem 1rem 0.75rem;

    .footer-title {
      font-size: 1.25rem;
    }

    .footer-subtitle {
      font-size: 0.875rem;
    }

    .social-links {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }

    .social-item {
      padding: 0.875rem;

      .social-icon {
        width: 36px;
        height: 36px;
        font-size: 16px;
      }

      .social-name {
        font-size: 0.875rem;
      }

      .social-handle {
        font-size: 0.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    margin: 2rem -0.5rem -0.5rem -0.5rem;
    padding: 1.25rem 0.5rem 0.75rem 0.5rem;

    .footer-section {
      margin-bottom: 1.5rem;
    }

    .footer-title {
      font-size: 1.125rem;
    }

    .social-item {
      padding: 0.75rem;

      .social-icon {
        width: 32px;
        height: 32px;
        font-size: 14px;
        margin-right: 0.75rem;
      }
    }
  }
}

.secondary-btn {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  border: none;
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 12px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(108, 117, 125, 0.3);
  font-size: 16px;

  &:hover {
    background: linear-gradient(135deg, #5a6268 0%, #343a40 100%);
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(108, 117, 125, 0.4);
    color: white;
  }

  i {
    margin-right: 0.5rem;
  }
}

.three-column-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .grid-item {
    background-color: #FFF;
    border-radius: 12px;
    padding: 1.25rem;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(238, 14, 76, 0.1);
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, #EE0E4C 0%, #FF6B9D 100%);
      transform: scaleX(0);
      transition: transform 0.3s ease;
    }

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(238, 14, 76, 0.15);
      border-color: rgba(238, 14, 76, 0.3);
      background: linear-gradient(135deg, #FFF 0%, #FFF8F9 100%);

      &::before {
        transform: scaleX(1);
      }
    }

    .grid-icon {
      margin-bottom: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      border-radius: 12px;
      box-shadow: 0 4px 12px rgba(238, 14, 76, 0.3);
      transition: all 0.3s ease;
      position: relative;

      img {
        filter: brightness(0) invert(1);
        transition: transform 0.3s ease;
      }
    }

    &:hover .grid-icon {
      transform: scale(1.1);
      box-shadow: 0 6px 16px rgba(238, 14, 76, 0.4);

      img {
        transform: scale(1.1);
      }
    }

    .grid-content {
      text-align: center;

      p.cabin-family.bold {
        color: #333;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 0;
        transition: color 0.3s ease;
      }
    }

    &:hover .grid-content p.cabin-family.bold {
      color: #EE0E4C;
    }

    @media (max-width: 768px) {
      padding: 1rem;
      min-height: 90px;
      border-radius: 10px;

      .grid-icon {
        width: 40px;
        height: 40px;
        margin-bottom: 0.5rem;
        border-radius: 10px;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .grid-content {
        p.cabin-family.bold {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }

    @media (max-width: 480px) {
      padding: 0.75rem;
      min-height: 80px;
      border-radius: 8px;
      flex-direction: row;
      text-align: left;
      justify-content: flex-start;

      .grid-icon {
        width: 36px;
        height: 36px;
        margin-bottom: 0;
        margin-right: 0.75rem;
        border-radius: 8px;
        flex-shrink: 0;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .grid-content {
        text-align: left;
        flex: 1;

        p.cabin-family.bold {
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 0;
        }
      }
    }

    @media (max-width: 360px) {
      padding: 0.5rem;
      min-height: 70px;

      .grid-icon {
        width: 32px;
        height: 32px;
        margin-right: 0.5rem;

        img {
          width: 18px;
          height: 18px;
        }
      }

      .grid-content {
        p.cabin-family.bold {
          font-size: 13px;
        }
      }
    }
  }
}

// Premium Plans Section Styles
.premium-title {
    color: #EE0E4C;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 1rem;
    font-family: 'Cabin', sans-serif;
  }

  .premium-subtitle {
    color: #333;
    font-size: 16px;
    text-align: center;
    margin-bottom: 2rem;
    line-height: 1.6;
    font-family: 'Cabin', sans-serif;
  }
.premium-plans-section {
  background: linear-gradient(135deg, #FFF 0%, #F8F9FA 100%);
  padding: 2rem;
  border-radius: 16px;
  margin: 2rem 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(238, 14, 76, 0.1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #EE0E4C, #FF6B9D, #EE0E4C);
  }

  .premium-plan-card {
    background: #FFF;
    border-radius: 12px;
    margin-bottom: 1.5rem;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    border: 1px solid #E5E5E5;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 24px rgba(238, 14, 76, 0.15);
      border-color: rgba(238, 14, 76, 0.3);
    }

    .plan-header {
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      padding: 1rem 1.5rem;
      color: white;

      .plan-title {
        font-size: 20px;
        font-weight: 700;
        margin: 0;
        font-family: 'Cabin', sans-serif;
      }
    }

    .plan-content {
      padding: 1.5rem;

      .plan-description {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 0.75rem;
        line-height: 1.5;
        font-family: 'Cabin', sans-serif;
      }

      .plan-details {
        font-size: 15px;
        color: #666;
        margin: 0;
        line-height: 1.6;
        font-family: 'Cabin', sans-serif;
      }
    }
  }

  .premium-cta {
    text-align: center;
    margin-top: 2rem;

    .premium-btn {
      background: linear-gradient(135deg, #EE0E4C 0%, #FF6B9D 100%);
      border: none;
      color: white;
      padding: 1rem 2rem;
      border-radius: 12px;
      font-weight: 600;
      font-size: 16px;
      font-family: 'Cabin', sans-serif;
      transition: all 0.3s ease;
      box-shadow: 0 4px 16px rgba(238, 14, 76, 0.3);
      cursor: pointer;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 24px rgba(238, 14, 76, 0.4);
        background: linear-gradient(135deg, #C00D3F 0%, #EE0E4C 100%);
      }
    }
  }

  // Responsive Design
  @media (max-width: 768px) {
    padding: 1.5rem;
    margin: 1.5rem 0;

    .premium-title {
      font-size: 24px;
    }

    .premium-subtitle {
      font-size: 15px;
    }

    .premium-plan-card {
      .plan-header {
        padding: 0.875rem 1.25rem;

        .plan-title {
          font-size: 18px;
        }
      }

      .plan-content {
        padding: 1.25rem;

        .plan-description {
          font-size: 15px;
        }

        .plan-details {
          font-size: 14px;
        }
      }
    }

    .premium-cta {
      .premium-btn {
        padding: 0.875rem 1.5rem;
        font-size: 15px;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 1rem;
    margin: 1rem 0;

    .premium-title {
      font-size: 22px;
    }

    .premium-subtitle {
      font-size: 14px;
      margin-bottom: 1.5rem;
    }

    .premium-plan-card {
      margin-bottom: 1rem;

      .plan-header {
        padding: 0.75rem 1rem;

        .plan-title {
          font-size: 16px;
        }
      }

      .plan-content {
        padding: 1rem;

        .plan-description {
          font-size: 14px;
        }

        .plan-details {
          font-size: 13px;
        }
      }
    }

    .premium-cta {
      margin-top: 1.5rem;

      .premium-btn {
        padding: 0.75rem 1.25rem;
        font-size: 14px;
      }
    }
  }
}

.switch-dashboard-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 14px;
  padding: 1.1rem 1.4rem;
  margin-top: 1.25rem;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.15s ease;

  &:active {
    opacity: 0.85;
    transform: scale(0.98);
  }

  &--mina {
    background: linear-gradient(135deg, #EE0E4C 0%, #F44777 100%);
    box-shadow: 0 4px 16px rgba(238, 14, 76, 0.3);
  }

  &--steward {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  }

  &__text {
    text-align: left;
  }

  &__title {
    font-family: 'Cabin', sans-serif;
    font-weight: 700;
    font-size: 15px;
    color: #fff;
    margin-bottom: 3px;
  }

  &__subtitle {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.78);
    margin-bottom: 0;
  }

  &__arrow {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.85);
    flex-shrink: 0;
    margin-left: 1rem;
  }
}
</style>
